import { digger } from '@cbre/digger';
import { defaultTxt, EMPTY_STRING, simpleValueValidation } from '@miq/utils';
import { ReportRecord } from '../../../../../models/report.model';
import { DisplayFnArgumentsInfo } from '../../../../../models/template.model';
import { CbreLogger } from '@cbre/logger';

export const RoleDescriptions = {
  TenantRep: 'Tenant Representative',
};

/**
 * Format Company/Contact records into string using company name and contact
 * display name.
 *
 * @param record
 * @param attributeInfo
 * @param requiredRole
 *
 * @example
 * Expected output from this method for a single tim record
 * CompanyName1 - Contact1,Contact2,Contact3
 * CompanyName2 - Contact2,Contact3,Contact4
 */
export function formatCompanyContactByRole(
  record: ReportRecord,
  attributeInfo: DisplayFnArgumentsInfo,
  requiredRole: string,
  logger? : CbreLogger
): string {
  if (!simpleValueValidation(attributeInfo.field)) {
    logger?.warn(`Missing field value for field: ${attributeInfo.id}`);
    return defaultTxt;
  }
  const companyContactRecords = digger(record.data, attributeInfo.field.split('/')[0]);
  const uniqueCompanyIds = [...new Set(companyContactRecords.map(item => item.company_id))];
  const formattedCompanyContacts: string[] = uniqueCompanyIds.map((companyId, index) => {
    // filter company/contact record by id and role
    const filteredCompanyContacts = companyContactRecords.filter(
      itemContact => itemContact.company_id === companyId && itemContact.role_desc === requiredRole
    );
    let companyName: string;
    if (filteredCompanyContacts.length) {
      companyName = filteredCompanyContacts[0].company_name;
      // join contact display names
      const contactsDisplayName = filteredCompanyContacts
        .filter(data => !!data && data.contact_display_name && data.contact_display_name !== '')
        .map(itemContact => itemContact.contact_display_name)
        .join(', ');
      return companyName
        ? companyName + (contactsDisplayName ? ' \n' + contactsDisplayName : EMPTY_STRING)
        : EMPTY_STRING;
    }
    return EMPTY_STRING;
  });
  return formattedCompanyContacts.length > 0
    ? formattedCompanyContacts.filter(data => data != EMPTY_STRING).join(' \n')
    : EMPTY_STRING;
}
